import type { LegalContent } from "@lib/content-defaults"
import { Facebook, Instagram, Threads } from "@modules/common/icons/social"

const PLATFORMS = [
  { key: "threads", label: "Threads", Icon: Threads },
  { key: "instagram", label: "Instagram", Icon: Instagram },
  { key: "facebook", label: "Facebook", Icon: Facebook },
] as const

/**
 * 官方社群連結。樣式跟 LINE 加好友同一套 CIS(白底、藍綠框與圖示),見 vibe.css 的 .v13-social。
 * - variant="icon":只有圖示(頁首桌機版,空間有限),平台名放在 aria-label 與 title
 * - variant="label":圖示+平台名(頁尾、側邊選單)
 * 沒有 "use client" 也沒用到 server 專用的東西,Nav/Footer(server)與 SideMenu(client)都能用。
 */
export default function SocialLinks({
  social,
  variant,
  className = "",
}: {
  social: LegalContent["social"]
  variant: "icon" | "label"
  className?: string
}) {
  const items = PLATFORMS.filter((p) => social?.[p.key])
  if (!items.length) return null

  return (
    <ul className={`v13-social v13-social--${variant} ${className}`}>
      {items.map(({ key, label, Icon }) => (
        <li key={key}>
          <a
            href={social[key]}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={variant === "icon" ? label : undefined}
            title={variant === "icon" ? label : undefined}
            data-testid={`social-${key}-link`}
          >
            <Icon size={variant === "icon" ? "16" : "18"} />
            {variant === "label" && <span>{label}</span>}
          </a>
        </li>
      ))}
    </ul>
  )
}
